import { render, staticRenderFns } from "./seloLogo.vue?vue&type=template&id=07d19c93&scoped=true"
import script from "./seloLogo.vue?vue&type=script&lang=js"
export * from "./seloLogo.vue?vue&type=script&lang=js"
import style0 from "./seloLogo.vue?vue&type=style&index=0&id=07d19c93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d19c93",
  null
  
)

export default component.exports